import gql from "graphql-tag";
import AssetDiscussionCommentFields from "../../fragments/AssetDiscussionCommentFields";
import AssetDiscussionCommentParticipantsFields from "../../fragments/AssetDiscussionCommentParticipantsFields";
import AssetDiscussionCommentRepliesPaginationFields from "../../fragments/AssetDiscussionCommentRepliesPaginationFields";

export default gql`
  query DiscussionCommentsByAsset(
    $assetId: ObjectID!
    $cursor: Cursor
    $limit: Int = 30
    $orderBy: AssetDiscussionCommentOrder
  ) {
    discussionCommentsByAsset(assetId: $assetId, cursor: $cursor, limit: $limit, orderBy: $orderBy)
      @connection(key: "discussionComments", filter: ["assetId"]) {
      nodes {
        replies(limit: 8) {
          ...AssetDiscussionCommentRepliesPaginationFields
        }
        participants(top: 5) {
          ...AssetDiscussionCommentParticipantsFields
        }
        ...AssetDiscussionCommentFields
      }
      totalCount
      pageInfo {
        cursor
        hasNextPage
      }
    }
  }

  ${AssetDiscussionCommentFields}
  ${AssetDiscussionCommentRepliesPaginationFields}
  ${AssetDiscussionCommentParticipantsFields}
`;
